<div>
  <span class="dialog-close" (click)="this.activeModal.close(false)">X</span>
  <div class="d-flex flex-column flex-lg-row justify-content-center mt-5 mb-5 gap-5 align-items-center modal-body">
    <div class="d-flex justify-content-center align-items-center product-img-container">
      <img
        class="product-img"
        [src]="product.images && product.images.length > 0 ? product.images[0].thumbnailBlobStorageUrl : ''"
        [alt]="product.name + ' image'"
      />
      <!-- uncomment this if we need to display points for each item
      <div class="d-flex justify-content-center align-items-center flex-column points">
        <div class="mt-2 points-text">{{ product.points | number }}</div>
        {{ 'points' | translate }}
      </div> -->
    </div>
    <div class="ms-3 ms-lg-0 d-flex flex-column gap-3 product-details">
      <div class="product-name" [innerHTML]="product.name | safeHtml"></div>
      <div>
        <div
          class="product-info"
          *ngIf="shortDescirption && !showLongDescription"
          [innerHTML]="shortDescirption | safeHtml"
        ></div>
        <div
          class="product-info"
          *ngIf="product.description && showLongDescription"
          [innerHTML]="product.description | safeHtml"
        ></div>
        <span
          *ngIf="shortDescirption.length === 150 && !this.showLongDescription"
          (click)="this.showLongDescription = !this.showLongDescription"
          class="show-more"
        >
          {{ showText }}</span
        >
      </div>
      <div class="product-points">
        {{ 'Value' | translate }}
        {{ product.points | number }}
      </div>
      <div class="d-flex gap-3 align-items-center">
        <!--  TODO https://motivforce.atlassian.net/browse/NUT-467 -->
        <button class="btn btn-primary btn-round" (click)="onConfirm()">
          {{ 'Add to cart' | translate }}
        </button>
        <button class="btn btn-outline-primary btn-round" (click)="activeModal.close()">
          {{ 'Continue Shopping' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
